// Definimos el método capitalize en el prototipo de String
String.prototype.capitalize = function() {
  if (!this) return '';
  return this
    .split(' ')
    .map(p => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
    .join(' ');
};
